import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDropDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7 10L12 15L17 10H7Z" }));
const ForwardRef = forwardRef(SvgArrowDropDown);
export { ForwardRef as ReactComponent };
